import { Controller } from '@hotwired/stimulus';
import Choices from 'choices.js';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = {
    url: String,
    scopeInputs: Object,
  };

  static targets = ['input'];

  get url() {
    return this.urlValue;
  }

  get scopedInputs() {
    const inputs = [];
    Object.keys(this.scopeInputsValue).forEach((key) => {
      const input = this.inputTarget.form.querySelector(`[name="${key}"]`);
      if (input) {
        inputs.push(input);
      }
    });
    return inputs;
  }

  get scopeInputsValues() {
    const scopes = {};
    Object.keys(this.scopeInputsValue).forEach((key) => {
      const value = this.scopeInputsValue[key];
      const input = this.inputTarget.form.querySelector(`[name="${key}"]`);
      if (input) {
        scopes[value] = input.value;
      }
    });
    return scopes;
  }

  async connect() {
    const self = this;
    this.choices = new Choices(this.inputTarget, {
      allowHTML: true,
      duplicateItemsAllowed: false,
      placeholderValue: 'Start typing to search...',
      removeItemButton: true,
      searchPlaceholderValue: 'Start typing to search...',
      searchResultLimit: 50,
    });
    this.inputTarget.addEventListener('search', async (e) => {
      await self.fetchChoices(e.detail.value);
    });
    this.scopedInputs.forEach((input) => {
      input.addEventListener('change', async () => {
        await self.fetchChoices();
      });
    });
  }

  async fetchChoices(q) {
    const self = this;
    const request = new FetchRequest(
      'post',
      self.url,
      {
        body: {
          q: q || '',
          ...this.scopeInputsValues,
        },
      },
    );
    const response = await request.perform();
    let results = [];
    if (response.ok) {
      results = await response.json;
    }
    this.choices.setChoices(results, 'value', 'label', true);
  }
}
